import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Valentina de Buenos Aires', 'Camila de Córdoba', 'Mariana de Rosario', 'Lucía de Mendoza', 'Fernanda de La Plata', 'Gabriela de Tucumán', 'Sofía de Mar del Plata', 'Isabella de Santa Fe', 'Martina de Salta', 'Daniela de Neuquén', 'Carolina de San Juan', 'Agustina de Bahía Blanca'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 4000);
    const showNotification = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      setCurrentName(randomName);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
      const nextDelay = Math.random() * 4000 + 8000 + 4000;
      setTimeout(showNotification, nextDelay);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-233">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-3 border-l-4 border-pastel-600 max-w-xs" data-id="element-234">
        <div className="bg-pastel-100 p-2 rounded-full" data-id="element-235">
          <CheckCircle2 className="w-5 h-5 text-pastel-700" data-id="element-236" />
        </div>
        <div data-id="element-237">
          <p className="text-sm font-medium text-gray-900" data-id="element-238">{currentName}</p>
          <p className="text-xs text-gray-500" data-id="element-239">acaba de comprar el MegaPack</p>
        </div>
      </div>
    </div>;
}